import { translateKey } from './translateKey';

const CAMELOT_PATTERN = /^\d{1,2}[AB]$/i;

export const isCamelotKey = (key: string | undefined | null): boolean =>
  !!key?.trim() && CAMELOT_PATTERN.test(key.trim());

export const toCamelotKey = (key: string | undefined | null): string => {
  const trimmed = key?.trim();
  if (!trimmed) return '';
  if (isCamelotKey(trimmed)) return trimmed.toUpperCase();
  const camelot = translateKey(trimmed, 'camelot');
  return isCamelotKey(camelot) ? camelot.toUpperCase() : trimmed;
};

/** Default display: Camelot only. */
export const formatMusicalKey = (
  key: string | number | null | undefined,
): string => {
  if (key == null) return '';
  if (typeof key === 'number') return '';
  if (typeof key !== 'string') return '';
  return toCamelotKey(key);
};

/** When standard notation is also needed: `4A / Dbm`. */
export const formatMusicalKeyWithStandard = (
  key: string | number | null | undefined,
): string => {
  if (key == null || typeof key === 'number') return '';
  const trimmed = key.trim();
  if (!trimmed) return '';
  if (isCamelotKey(trimmed)) return trimmed.toUpperCase();
  const camelot = toCamelotKey(trimmed);
  if (isCamelotKey(camelot)) return `${camelot} / ${trimmed}`;
  return camelot || trimmed;
};
